import { render } from "./cont_stata.vue?vue&type=template&id=9083cc6a"
import script from "./cont_stata.vue?vue&type=script&lang=js"
export * from "./cont_stata.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/users/profile/info/tabs/cont_stata.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9083cc6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9083cc6a', __exports__)) {
    console.log('reload')
    api.reload('9083cc6a', __exports__)
  }
  
  module.hot.accept("./cont_stata.vue?vue&type=template&id=9083cc6a", () => {
    console.log('re-render')
    api.rerender('9083cc6a', render)
  })

}


export default __exports__